import { useCallback, useState } from 'react'
import { ILeadDetail } from '@user/store/lead'
import { IOpportunityDetail } from '@user/store/opportunity'
import { LocationOrContact } from '@user/components/Contacts/hooks/useCleanupEntityContacts'

export function useUpdateContact(detail?: ILeadDetail | IOpportunityDetail) {
  const [updateContactId, setUpdateContactId] = useState<number>()
  const [showUpdateContact, setShowUpdateContact] = useState(false)
  const [isLocation, setIsLocation] = useState(false)
  const [item, setItem] = useState<LocationOrContact>()

  const updateContactIsPrimary = updateContactId === detail?.primaryContact.id

  const onCloseUpdateContact = useCallback(() => {
    setShowUpdateContact(false)
    setUpdateContactId(undefined)
    setIsLocation(false)
  }, [])

  const onClickAddSecondaryContact = useCallback(() => {
    setShowUpdateContact(true)
    setUpdateContactId(undefined)
  }, [])

  const onClickEdit = useCallback(
    (contactId: number, item: LocationOrContact) => {
      setShowUpdateContact(true)
      setUpdateContactId(contactId)
      setIsLocation(item?.type === 'location')
      setItem(item)
    },
    [],
  )

  return {
    onClickEdit,
    updateContactId,
    showUpdateContact,
    onCloseUpdateContact,
    updateContactIsPrimary,
    onClickAddSecondaryContact,
    isLocation,
    item,
  }
}
